import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Flipbook } from "@/components/site/Flipbook";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Flipbook />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
